import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { RootState } from '@store/types';
import { selectAccordionRowState, toggleStart } from '@reducers/v2/tableAccordion/tableAccordion.slice';

export interface UseAccordionRowReturn<TData = unknown> {
  isExpanded: boolean;
  isLoading: boolean;
  isClosing: boolean;
  data: TData | null;
  toggle: () => void;
}

export const useAccordionRow = <TData = unknown>(rowKey: string | number): UseAccordionRowReturn<TData> => {
  const dispatch = useAppDispatch();

  // Subscribe only to this specific row's state
  const rowState = useSelector((state: RootState) => selectAccordionRowState<TData>(state, rowKey));

  // Memoize toggle handler
  const toggle = useCallback(() => {
    dispatch(toggleStart({ rowKey }));
  }, [dispatch, rowKey]);

  return {
    ...rowState,
    toggle,
  };
};
